import { useCallback, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useRoomContext } from '@src/contexts';
import { openURL } from '@src/utils';
import { isWebView } from '@src/helpers';

import { EWebinarRoutes } from '@src/constants';

import { IScheduledMeeting } from '@src/types';

interface IProps {
  meeting: IScheduledMeeting;
}

const useMeetingCard = ({ meeting }: IProps) => {
  const [isOptionsOpen, setIsOptionsOpen] = useState(false);

  const { isMobileDevice } = useRoomContext();
  const navigate = useNavigate();

  const { joinLink, joinPath, updateLink, registrationLink, prefixedTitle, inviteLink } = useMemo(() => {
    const updateLink = `${EWebinarRoutes.UPDATE}?wid=${meeting.id}`;
    const registrationLink = `${EWebinarRoutes.REGISTRATION_FORM}?wid=${meeting.id}`;
    
    // Only add title parameter if in WebView
    const titleParam = isWebView() ? `&title=${encodeURIComponent(meeting.roomTitle)}` : '';
    const joinLink = `${EWebinarRoutes.JOIN}?wid=${meeting.id}${titleParam}`;

    const prefixedTitle = `${meeting.roomTitle.charAt(0).toUpperCase()}${meeting.roomTitle.slice(1)}`;
    const invitePath = meeting.roomSetting?.registrationRequired ? registrationLink : joinLink;
    const inviteLink = `${window.location.origin}${invitePath}`;
    const joinPath = `${window.location.origin}${joinLink}`;

    return {
      joinLink,
      joinPath,
      updateLink,
      inviteLink,
      prefixedTitle,
      registrationLink,
    };
  }, [meeting]);

  const joinWebinar = useCallback(() => {
    setIsOptionsOpen(false);
    openURL(joinPath, true);
  }, [joinPath, setIsOptionsOpen]);

  return {
    joinLink,
    inviteLink,
    updateLink,
    registrationLink,
    isMobileDevice,
    isOptionsOpen,
    setIsOptionsOpen,
    prefixedTitle,
    joinWebinar,
    navigate,
  };
};

export default useMeetingCard;
